import "./App.css";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontSizeProvider } from "./context/FontContext";
import { SideBarProvider } from "./context/SideBarContext";
import { ActiveTabProvider } from "./context/ActiveTab";
import { ThemeProvider } from "./context/ThemeContext";
import Loader from "./layout/Loader";
import { useAuthContext } from "./hooks/useAuthContext";

// Lazy load all major components
const Login = lazy(() => import("./user/Login"));
const SignUp = lazy(() => import("./user/SignUp"));
const ForgotPassword = lazy(() => import("./user/ForgotPassword"));
const Home = lazy(() => import("./screen/Home"));
const LandingPage = lazy(() => import("./screen/LandingPage"));
const Chapters = lazy(() => import("./screen/Chapters"));
const Glossary = lazy(() => import("./screen/Glossary"));
const Preface = lazy(() => import("./screen/Preface"));
const AboutTheBook = lazy(() => import("./screen/AboutTheBook"));
const Quran = lazy(() => import("./screen/Quran"));
const Settings = lazy(() => import("./screen/Settings"));
const ChapterList = lazy(() => import("./layout/ChapterList"));
const Search = lazy(() => import("./layout/Search"));
const KeyWords = lazy(() => import("./screen/KeyWords"));

function App() {
  const { user, isAuthReady } = useAuthContext();
  return (
    <div className="mobile-screen max-w-2xl mx-auto w-full ">
      <BrowserRouter>
        <ToastContainer theme="dark" />
        <FontSizeProvider>
          <ThemeProvider>
            <SideBarProvider>
              <ActiveTabProvider>
                {isAuthReady && (
                  <Routes>
                    <Route
                      path="/"
                      element={
                        !user ? (
                          <Suspense fallback={<Loader />}>
                            <Login />
                          </Suspense>
                        ) : (
                          <Navigate to="/welcome" />
                        )
                      }
                    />
                    <Route
                      path="/register"
                      element={
                        !user ? (
                          <Suspense fallback={<Loader />}>
                            <SignUp />
                          </Suspense>
                        ) : (
                          <Navigate to="/welcome" />
                        )
                      }
                    />
                    <Route
                      path="/forgot-password"
                      element={
                        <Suspense fallback={<Loader />}>
                          <ForgotPassword />
                        </Suspense>
                      }
                    />
                    <Route
                      path="/home"
                      element={
                        user ? (
                          <Suspense fallback={<Loader />}>
                            <Home />
                          </Suspense>
                        ) : (
                          <Navigate to="/" />
                        )
                      }
                    />
                    <Route
                      path="/preface"
                      element={
                        user ? (
                          <Suspense fallback={<Loader />}>
                            <Preface />
                          </Suspense>
                        ) : (
                          <Navigate to="/" />
                        )
                      }
                    />
                    <Route
                      path="/aboutTheBook"
                      element={
                        user ? (
                          <Suspense fallback={<Loader />}>
                            <AboutTheBook />
                          </Suspense>
                        ) : (
                          <Navigate to="/" />
                        )
                      }
                    />
                    <Route
                      path="/settings"
                      element={
                        user ? (
                          <Suspense fallback={<Loader />}>
                            <Settings />
                          </Suspense>
                        ) : (
                          <Navigate to="/" />
                        )
                      }
                    />
                    <Route
                      path="/chapters/chapter-list"
                      element={
                        <Suspense fallback={<Loader />}>
                          <ChapterList />
                        </Suspense>
                      }
                    />
                    <Route
                      path="/chapters/search"
                      element={
                        <Suspense fallback={<Loader />}>
                          <Search />
                        </Suspense>
                      }
                    />
                    <Route
                      path="/chapters"
                      element={
                        user ? (
                          <Suspense fallback={<Loader />}>
                            <Chapters />
                          </Suspense>
                        ) : (
                          <Navigate to="/" />
                        )
                      }
                    >
                      <Route
                        path="/chapters"
                        element={
                          <Suspense fallback={<Loader />}>
                            <Quran />
                          </Suspense>
                        }
                      />
                      <Route
                        path="keywords"
                        element={
                          <Suspense fallback={<Loader />}>
                            <KeyWords />
                          </Suspense>
                        }
                      />
                      <Route
                        path="glossary"
                        element={
                          <Suspense fallback={<Loader />}>
                            <Glossary />
                          </Suspense>
                        }
                      />
                    </Route>
                    <Route
                      path="/welcome"
                      element={
                        user ? (
                          <Suspense fallback={<Loader />}>
                            <LandingPage />
                          </Suspense>
                        ) : (
                          <Navigate to="/" />
                        )
                      }
                    />
                  </Routes>
                )}
              </ActiveTabProvider>
            </SideBarProvider>
          </ThemeProvider>
        </FontSizeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
// https://github.com/senthiltechspot/Whatsapp-Clone/blob/master/Backend/Controllers/Chat.controller.js
